import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CircleCheck } from "lucide-react";

const INCLUDED = [
  "No setup fee",
  "No lock-in contract",
  "Cancel anytime",
  "LEO included",
  "7FC Job Hub included",
  "Automated SMS and email follow-up included",
  "Recommended Meta ad budget from $30 / day",
  "Ad spend paid separately and directly to Meta",
];

const Pricing = () => {
  return (
    <section id="pricing" className="bg-gray-50/70 py-14 sm:py-20">
      <div className="mx-auto max-w-5xl px-5 sm:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-black uppercase tracking-tight text-brand-black sm:text-4xl">
            One Simple <span className="text-brand-blue">Weekly Fee.</span> Everything Included.
          </h2>
        </div>

        <div className="mx-auto mt-10 max-w-3xl overflow-hidden rounded-[32px] bg-white shadow-lg ring-1 ring-gray-200">
          <div className="relative bg-gradient-to-br from-blue-50 via-white to-blue-50 px-8 py-10 text-center sm:px-10 sm:py-12">
            <p className="text-xs font-black uppercase tracking-widest text-brand-blue">
              Simple Weekly Fee
            </p>
            <div className="mt-3 flex items-baseline justify-center gap-2">
              <span className="text-5xl font-black leading-none tracking-tight text-brand-black sm:text-6xl">
                $250
              </span>
              <span className="text-lg font-black uppercase tracking-tight text-brand-black sm:text-2xl">
                / Week + GST
              </span>
            </div>
            <p className="mt-4 text-xs font-black uppercase tracking-widest text-brand-grayMid">
              No Setup Fee · No Lock-In · Cancel Anytime
            </p>
          </div>

          <div className="border-t border-gray-100 px-6 py-8 sm:px-10 sm:py-10">
            <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4">
              {INCLUDED.map((line) => (
                <li key={line} className="flex items-start gap-2.5">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand-blue/10 text-brand-blue ring-1 ring-brand-blue/20">
                    <CircleCheck className="h-3 w-3" />
                  </span>
                  <span className="text-sm font-medium leading-snug text-brand-black">{line}</span>
                </li>
              ))}
            </ul>

            <Link
              to="/offer"
              className="mt-8 inline-flex w-full min-h-[56px] items-center justify-center gap-2 rounded-2xl bg-brand-blue px-7 py-4 text-sm font-black uppercase tracking-wider text-white shadow-xl shadow-blue-200/60 ring-1 ring-blue-700/10 transition-all hover:bg-blue-600 active:scale-[0.99]"
            >
              Check If My Territory Is Available <ArrowRight className="h-5 w-5" />
            </Link>
            <p className="mt-3 text-center text-xs italic text-brand-grayMid">
              Ad spend is paid directly to Meta on your own account.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
